var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecentWorkAndEconomicGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "decent-work-and-economic-growth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 386",
    fill: "#ffffff",
    d: "M4.261214285714286 12.162428571428572V4.930714285714285l0.52 -0.5079285714285715L6.760000000000001 6.396l1.522857142857143 -1.516357142857143v7.282785714285715H4.262142857142857Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#fdba74",
    d: "M12.09 1.0567142857142857 8.284714285714287 4.887071428571429v7.276285714285715h3.805285714285714s0.24235714285714288 -4.168357142857143 0.24235714285714288 -6.8407857142857145c0 -3.511857142857143 -0.24235714285714288 -4.2658571428571435 -0.24235714285714288 -4.2658571428571435Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fill: "#fdba74",
    d: "m0.4355 8.76107142857143 0.45592857142857146 3.4022857142857146h3.3725714285714288V4.923285714285714L0.43642857142857144 8.76107142857143Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 381",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0.7475 8.454642857142858 4.033714285714286 -4.033714285714286L6.760000000000001 6.4006428571428575l4.893571428571429 -4.8926428571428575",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.155000000000001 3.0160000000000005c0.08078571428571428 -0.8022857142857143 0.08078571428571428 -1.2433571428571428 0 -2.010357142857143 -0.767 -0.07985714285714285 -1.2071428571428573 -0.07985714285714285 -2.010357142857143 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 383",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.261214285714286 12.163357142857144 0 -4.366142857142857",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 384",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.284714285714287 12.163357142857144 0 -4.366142857142857",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 387",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0.7094285714285715 10.798357142857142 0.18200000000000002 1.365 11.121500000000001 0 0.25721428571428573 -6.117428571428571",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecentWorkAndEconomicGrowth);
export default __webpack_public_path__ + "static/media/decent-work-and-economic-growth.c6a700cdf68737f820ad6b6b7691d595.svg";
export { ForwardRef as ReactComponent };